<icon type="exclamation-circle-fill"></icon>
<ng-content></ng-content>
